const IS_TABLE_TYPE = {
  NON_TABLE: {
    code: '0',
    label: 'common.typeList.contractIsTableType.noTable',
  },
  HAS_TABLE: {
    code: '1',
    label: 'common.typeList.contractIsTableType.hasTable',
  },
};

export default IS_TABLE_TYPE;
